// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__4hRh-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__NnJxx"};